import { takeLatest, put, all, call } from 'redux-saga/effects';
import { AxiosCall } from "../../../utils/axios";
import * as actions from './actions';

function* fetchTrendingData() {
    try {
        const result = yield call(AxiosCall, '/dashboard/trending/trending/');
        yield put(actions.fetchTrendingDataSuccess(result.data));
    } catch (e) {
        yield put(actions.fetchTrendingDataFailure(e));
    }
}

export default function* trendingDataSaga() {
    yield all([
        // Watchers
        takeLatest(actions.FETCH_TRENDING_DATA.REQUEST, fetchTrendingData),
    ])
}
